import { createContext, useContext } from "react";

export type ZoomStep = {
  name: string;
  scale: number;
};

type ZoomContext = {
  zoom: number;
  zoomSteps: ZoomStep[];
  onZoomIn: () => void;
  onZoomOut: () => void;
  onChangeZoom: (zoom: number) => void;
};

export const ZoomContext = createContext<ZoomContext | undefined>(undefined);

export const useZoom = () => {
  const context = useContext(ZoomContext);

  if (!context) throw new Error(`Expected "ZoomContext.Provider" in component tree.`);

  return context;
};
